import { render, staticRenderFns } from "./UndoDeleteBlog.vue?vue&type=template&id=e73ac22e"
import script from "./UndoDeleteBlog.vue?vue&type=script&lang=js"
export * from "./UndoDeleteBlog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports